import { FC } from 'react';

import { EStatisticType } from 'views/Statistics/StatisticsView.types';

import {
  getDescriptiveLabelFromDate,
  getFormattedValueByType
} from '../utils';

import { CurrentTrendLegendMarker } from './LegendMarkers/CurrentTrendLegendMarker';
import { PreviousTrendLegendMarker } from './LegendMarkers/PreviousTrendLegendMarker';
import { TrendsSeparator } from './TrendsSeparator';

type MultipleTrendsLegendProps = {
  currentDate: string;
  previousDate: string;
  metricType: EStatisticType;
  currentValue: number;
  previousValue: number;
};

export const MultipleTrendsLegend: FC<MultipleTrendsLegendProps> = ({
  currentDate,
  previousDate,
  metricType,
  currentValue,
  previousValue
}) => {
  const renderTrend = (time: string, value: number, icon?: React.ReactNode) => {
    return (
      <>
        <div className="flex items-start gap-2 w-full mt-2">
          <div className="flex-shrink-0">{icon}</div>
          <p className="text-base-popoverForeground text-p-xs">
            {getDescriptiveLabelFromDate(time)}
          </p>
        </div>
        <p className="text-base-popoverForeground text-p-m">
          {getFormattedValueByType(value, metricType)}
        </p>
      </>
    );
  }

  return (
    <div>
      <TrendsSeparator />
      {renderTrend(currentDate, currentValue, <CurrentTrendLegendMarker />)}
      {<TrendsSeparator />}
      {renderTrend(previousDate, previousValue, <PreviousTrendLegendMarker />)}
    </div>
  );
}
